module.exports = __webpack_public_path__ + "img/177.749ce943.jpg";